var MarkupIt = require('../../');

module.exports = MarkupIt.Syntax('markdown', {
    entryRule: require('./document'),

    // List of rules for parsing blocks
    inline: require('./inline'),

    // List of rules for parsing inline styles/entities
    blocks: require('./blocks')
});



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/syntaxes/markdown/index.js
// module id = 317
// module chunks = 0